module.exports = __webpack_public_path__ + "static/media/sea.af0a187a.png";